var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOhm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "e155acb553"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.484375 0 L 29.515625 0 L 29.515625 29.03125 L 0.484375 29.03125 Z M 0.484375 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "77ca9fa4f2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.484375 0 L 29.515625 0 L 29.515625 29 L 0.484375 29 Z M 0.484375 0 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e155acb553)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.484375 0 L 29.515625 0 L 29.515625 29.03125 L 0.484375 29.03125 Z M 0.484375 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.484375 0 L 29.515625 0 L 29.515625 29.03125 L 0.484375 29.03125 Z M 0.484375 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#77ca9fa4f2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4f9fca",
    d: "M 21.308594 24.414062 L 21.308594 24.914062 L 27.269531 24.914062 L 28.421875 21.382812 L 29.589844 21.382812 L 27.347656 28.84375 L 17.664062 28.84375 C 19.199219 26.082031 20.359375 23.300781 21.144531 20.503906 C 21.929688 17.703125 22.324219 14.972656 22.324219 12.3125 C 22.324219 8.773438 21.714844 6.101562 20.492188 4.300781 C 19.269531 2.496094 17.460938 1.59375 15.054688 1.59375 C 12.640625 1.59375 10.820312 2.492188 9.601562 4.28125 C 8.378906 6.070312 7.769531 8.746094 7.769531 12.3125 C 7.769531 14.984375 8.160156 17.710938 8.9375 20.484375 C 9.71875 23.257812 10.882812 26.042969 12.429688 28.84375 L 2.726562 28.84375 L 0.503906 21.382812 L 1.671875 21.382812 L 2.804688 24.914062 L 8.785156 24.914062 L 8.785156 24.414062 C 6.675781 22.074219 5.160156 19.933594 4.242188 17.988281 C 3.320312 16.046875 2.859375 14.058594 2.859375 12.027344 C 2.859375 8.613281 4.03125 5.777344 6.371094 3.523438 C 8.710938 1.265625 11.605469 0.136719 15.054688 0.136719 C 18.507812 0.136719 21.398438 1.269531 23.734375 3.53125 C 26.066406 5.792969 27.230469 8.625 27.230469 12.027344 C 27.230469 14.046875 26.773438 16.019531 25.859375 17.953125 C 24.949219 19.882812 23.429688 22.035156 21.308594 24.414062 Z M 21.308594 24.414062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOhm);
export default __webpack_public_path__ + "static/media/ohm.d1a045bee31331b74141036fc856fec4.svg";
export { ForwardRef as ReactComponent };